import { createRouter } from '@tanstack/react-router';

import type { TRouterContext } from './router/types';
import { routeTree } from './routeTree.gen';

const defaultContext: TRouterContext = {
  auth: {
    isAuthenticated: false,
    userId: null,
    token: null,
    userPermission: null,
    isSubscriptionExpired: false,
  },
};

// @ts-expect-error TanStack Router requires strictNullChecks: true, but this project has it disabled
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  context: defaultContext,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
